import { useAuth } from "react-oauth2-pkce";
import { useEffect, useState } from "react";
import {  ApiLoadingSpinner } from "@funcional/react-ui";
import envConfig from "../../../config";

//const outSystensApplication = "https://multi.funcionalmais.com/";
console.debug('proc', process.env);
//const outSystensApplication = envConfig('PORTAL_RH_URL');
const outSystensApplication = "https://funcionalcorp-tst1.outsystemsenterprise.com/PortalRH";
//const outSystensApplicationAPI = envConfig('PORTAL_RH_URL_API');
const outSystensApplicationAPI = "https://funcionalcorp-tst1.outsystemsenterprise.com/PortalRH_API";

console.debug("outSystensApplication", outSystensApplication);

export default function OutSystensPage() {
  const { authService } = useAuth();
  const [ token, setToken ] = useState<string>("");
  const jwt = authService.getAuthTokens().access_token;

  useEffect(() => {
    if (token !== "") {
      return;
    }

    fetch(`${outSystensApplicationAPI}/rest/Login/Token`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        "Token": jwt
      })
    })
    .then(response => response.json())
    .then(data => {
      setToken(data.Jit);
    })
    .catch(error => {
      console.error(error);
    });
  }, [token]);

  if (token == "") {
    return (
      <div className="flex justify-center items-center w-full">
        <ApiLoadingSpinner message={"Iniciando módulo"} />
      </div>
    )
  }

  window.location.href = `${outSystensApplication}?token=${token}`;
  return null;
}
